import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UserApiService } from 'src/app/core/services/user-api.service';
import { News } from 'src/app/core/types';

@Component({
    selector: 'gl-news-item',
    templateUrl: './news-item.component.html',
    styleUrls: ['./news-item.component.scss'],
    standalone: false
})
export class NewsItemComponent {
  @Input() public news: News;
  @Output() public dismiss = new EventEmitter();

  constructor(private userApiService: UserApiService, private translate: TranslateService) {}

  public goToUrl(url: string) {
    window.open(url, '_blank');
  }

  public dismissNews() {
    this.userApiService
      .dismissNewsNotifications(this.translate.currentLang, this.news.id)
      .subscribe(() => this.dismiss.emit());
  }

  public dataChange(date: string) {
    return new Date(date).toLocaleDateString();
  }
}
